export default __webpack_public_path__ + "static/media/06@2x.5eac8ae8.png";